import React from 'react';
import {reduxForm} from 'redux-form';
import FormField from '../form/form-field';
import BaseForm from '../form/base-form';
import LocalizedStrings from '../../localization/strings';

import Button from '../button';

import {validateRequiredFields} from '../../utils/form';
import Alert from '../alert';

const fields = ['id', 'name', 'order'];

function validate(values) {
    let errors = {
        _error: null
    };
    errors = validateRequiredFields(values, [
        'name'
    ], errors);
    return errors;
}

class PartnerCategoryForm extends BaseForm {
    render() {
        const {
            submitting,
            error,
            handleSubmit,
            fields: {
                name,
                order
            }
        } = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <FormField label={LocalizedStrings.name} name="name" field={name}>
                        <input ref="name" className="border-full larger" placeholder={LocalizedStrings.name}
                               type="text" {...name}/>
                    </FormField>

                    <FormField label={LocalizedStrings.order} name="order" field={order}>
                        <input ref="link" className="border-full larger" placeholder={LocalizedStrings.order}
                               type="number" {...order}/>
                    </FormField>

                    <div className="actions-row">
                        <Button loading={submitting} submit={true} disabled={submitting} type="primary">
                            {LocalizedStrings.submit}
                        </Button>

                    </div>

                </form>
            </div>
        )
    }
}

export default reduxForm({
    form: 'partner-category-form',
    fields,
    validate,
    destroyOnUnmount: true
}, state => ({initialValues: state.admin.partnerCategories.category}))(PartnerCategoryForm);



// WEBPACK FOOTER //
// ./src/js/components/partner-category/partner-category-form.js